<template>
  <div
    class="mainScroll"
    :class="{
      'have-validate': multiple && !searchInput,
      'have-validate-input': multiple && searchInput,
      'have-validate-no-button': !multiple && searchInput,
      'have-validate-no-button-no-search': !multiple && !searchInput
    }"
  >
    <div class="mainTable">
      <table v-if="filteredData.length > 0">
        <tbody>
          <tr
            v-for="(entry, index) in filteredData"
            :key="index"
            :class="{ separator: entry.label === 'separator' }"
            @click="[$emit('dataSelected', [entry]), storeSelected(entry)]"
          >
            <template v-if="multiple && entry.label !== 'separator'">
              <td v-if="entry.label">
                {{ $te(`form.${entry.label}`) ? $t(`form.${entry.label}`) : entry.label }}
              </td>
              <td v-else>
                {{ $te(`form.${entry.value}`) ? $t(`form.${entry.value}`) : entry.value }}
              </td>
              <td>
                <input
                  type="checkbox"
                  :checked="checkSelected(entry)"
                >
              </td>
            </template>
            <template v-else-if="entry.label !== 'separator'">
              <td
                v-for="(key, indexColumns) in columns"
                :key="indexColumns"
                :style="hideValue ? 'width:100%;text-align:left' : null"
              >
                {{ key !== 'value' ? entry[key] : '' }}
              </td>
            </template>
          </tr>
        </tbody>
      </table>
      <div
        v-else
        class="empty"
      >
        {{ $t(`clientList.errors.${title}_empty`) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  filters: {
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
  // Data : data object from parent component
  // Columns : Define data columns for display
  // Filterkey: Search from input parent component
  // Multiple: Have multiple line selectable
  props: {
    data: {
      type: Array,
      default: () => []
    },
    defaultSelected: {
      type: Array,
      default: () => []
    },
    filterKey: {
      type: String,
      default: ''
    },
    type_list: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    searchInput: {
      type: Boolean,
      default: false
    },
    hideValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['dataSelected', 'validate'],
  data() {
    return {
      multiDataSelected: []
    }
  },
  computed: {
    // Filter data from string input and remove duplicate
    filteredData() {
      const filterKey = this.filterKey && this.filterKey.toLowerCase()
      let { data } = this
      if (filterKey) {
        data = data.filter(row =>
          Object.keys(row).some(key => String(row[key]).toLowerCase().indexOf(filterKey) > -1)
        )
        data = this.removeDuplicateFromArray(data)
      }
      return data
    },
    columns() {
      if (this.hideValue) {
        return ['label']
      }
      return ['label', 'value']
    }
  },
  mounted() {
    if (this.multiple) {
      this.multiDataSelected = this.defaultSelected
    }
  },
  methods: {
    removeDuplicateFromArray(things) {
      return things.filter(
        (thing, index, self) =>
          index ===
          self.findIndex(t => (t.label === thing.label && t.value === thing.value) || t.value === thing.value)
      )
    },
    // store data for multi line selectable
    storeSelected(data) {
      if (this.multiple) {
        if (
          this.multiDataSelected.some(elem => {
            return JSON.stringify(data.value) === JSON.stringify(elem.value)
          })
        ) {
          const index = this.multiDataSelected.findIndex(i => i.value === data.value)
          if (index > -1) {
            this.multiDataSelected.splice(index, 1)
          }
        } else {
          this.multiDataSelected.push(data)
        }
        this.$emit('dataSelected', this.multiDataSelected)
      } else {
        this.$emit('validate', data)
      }
    },
    // Check if data is already selected
    checkSelected(data) {
      for (const iterator of this.multiDataSelected) {
        if (iterator.value === data.value && this.multiple) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
  .have-validate {
    height: calc(100vh - 120px) !important;
  }

  .have-validate-no-button {
    height: calc(100vh - 90px) !important;
  }

  .have-validate-no-button-no-search {
    height: calc(100vh - 60px) !important;
  }

  .have-validate-input {
    height: calc(100vh - 135px) !important;
  }

  .mainScroll {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: calc(100vh - 110px);

    .mainTable::-webkit-scrollbar {
      display: none;
    }

    .mainTable {
      overflow: hidden scroll;
      flex-grow: 1;
      margin-bottom: 10px;

      input[type='checkbox'] {
        height: 16px;
        width: 16px;
        border: 1px solid #b4b4b4;
        -webkit-appearance: none;
        appearance: none;
      }

      input[type='checkbox']:checked {
        background-image: url('@/assets/img/cross.svg');
        background-color: #fff;
        background-repeat: no-repeat;
        background-size: cover;
      }

      .separator {
        height: 0;
        border-top: 2px solid black;
        border-bottom: none;
        margin-bottom: -10px;
        margin-top: -1px;
      }

      table {
        width: 100%;
        margin-top: 5px;
      }

      tr {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        border-bottom: 1px solid rgb(218 218 218);
        padding-bottom: 15px;
        padding-top: 15px;
        cursor: pointer;

        td:first-child {
          width: 80%;
        }

        td:last-child {
          width: 20%;
          text-align: right;
        }
      }

      tr:first-child {
        border-top: 1px solid rgb(218 218 218);
      }

      .empty {
        margin-top: 30px;
      }
    }
  }
</style>
